import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const addProfileData = createAsyncThunk(
  "Candidates/add",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(API_URL.CANDIDATES.SLUG, payload);
      return response.data;
    } catch (error) {
      // console.log("error api call", error.response);
      return rejectWithValue(error);
    }
  }
);

export const getProfileData = createAsyncThunk(
  "Candidates/get",
  async (userId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${API_URL.CANDIDATES.SLUG}/${userId}`);
      return data.data;
    } catch (error) {
      // console.log("error api call", error.response);
      return rejectWithValue(error);
    }
  }
);

export const editProfileData = createAsyncThunk(
  "Candidates/edit",
  async (formData, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(
        `${API_URL.CANDIDATES.SLUG}/${formData.id}`,
        formData
      );
      return data.data;
    } catch (error) {
      // console.log("error api call", error.response);
      return rejectWithValue(error);
    }
  }
);

export const addProfilePhotoData = createAsyncThunk(
  "Candidates/add",
  async ({ formData, id }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_URL.CANDIDATES.SLUG}/${id}/UploadPicture`,
        formData
      );
      return response.data;
    } catch (error) {
      // console.log("error api call", error.response);
      return rejectWithValue(error);
    }
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState: {
    data: null,
    loading: false,
    error: null,
    userValues: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addProfileData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addProfileData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addProfileData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getProfileData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProfileData.fulfilled, (state, action) => {
        state.loading = false;
        state.userValues = action.payload;
      })
      .addCase(getProfileData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editProfileData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editProfileData.fulfilled, (state, action) => {
        state.loading = false;
        state.userValues = action.payload;
      })
      .addCase(editProfileData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default profileSlice.reducer;
